import type { ParticipantTaskTemplate } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';

interface Props {
  taskTemplate: ParticipantTaskTemplate;
}

export const ParticipantTaskTemplateDate = (props: Props) => {
  const { taskTemplate } = props;

  const text = P.run(() => {
    if (taskTemplate.requiresDueDate) {
      return 'Requires a due date';
    }

    return 'No due date';
  });

  const color = P.run(() => {
    if (taskTemplate.requiresDueDate) {
      return 'orange.400';
    }

    return 'gray.500';
  });

  return (
    <ChakraV3.Text color={color} fontSize='xs' fontWeight='semibold'>
      {text}
    </ChakraV3.Text>
  );
};
